export default __webpack_public_path__ + "static/media/work-item-alt3.f9ba773e.svg";